import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

import React from 'react';
import { useSelector } from 'react-redux';
import { AppState, franchiseSelector } from '../../common/store/store';

export const HeadSection = () => {

    const franchise = useSelector((state: AppState) => franchiseSelector.selectById(state, state.device.currFranchise));

    return <Box sx={{ backgroundImage: "url('images/chalet_patio_sur_pieux.jpg')", backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <Box className='dark header'>
            <Container sx={{ opacity: 1, pt: { xs: 4, sm: 4, md: 4, lg: 8 }, pb: { xs: 1, sm: 1, md: 3, lg: 5 }, textAlign: 'center', textShadow: '0px 0px 5px black' }}>
                <div dangerouslySetInnerHTML={{ __html: franchise?.homeText ?? '' }} />
                {/*<Typography variant='h3'><strong className='white'>La référence</strong></Typography>
                <Typography variant='h4' sx={{ maxWidth: 450, margin: '0 auto' }}>en <strong>fabrication</strong> et <strong className='white'>installation</strong> de pieux vissés galvanisés <strong>robustes</strong> et <strong>durables</strong>.</Typography>
                {franchise?.id == 1 ? <Typography sx={{ marginY: 2 }} variant='h4'><strong className='white'>Stabilisation</strong> et <strong>redressissement</strong> de maison avec système de <strong>pieux hydraulique.</strong></Typography> : null}
                <Typography variant='h4' sx={{ marginY: 2 }}>Service de qualité <strong>incomparable</strong> <strong className='white'> !<ThumbUp /></strong></Typography>
                <Typography variant='h4'><strong>Protégez</strong> votre investissement avec <strong className='white'>Pieux Protech</strong>!</Typography>
                <Typography>Au service des particuliers et entrepreneurs <strong>depuis {Math.floor(diff.years)} ans.</strong></Typography>
                */ }
                <Box component='img' alt='Logo Pieux Protech' title='Logo Pieux Protech' src="/images/PieuxProTechBlanc.png" sx={{ maxHeight: '200px' }}></Box>


            </Container>
        </Box>
    </Box>;
};
